import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { LoggerService } from 'src/app/services/Non-Master/logger.service';
import { DateTimeConvertService } from 'src/app/services/CommonService/DateTimeConvert.service';
import { tPrescriptionHeadModelWithPatientBPInfo, tPrescriptionHeadModel } from 'src/app/models/tPrescriptionHeadModel';
import { MatTableDataSource, MatPaginator } from '@angular/material';

import { tPrescriptionService } from 'src/app/services/tPrescription.service';
import { TranslateService } from '@ngx-translate/core';

import { tOnConsultService } from 'src/app/services/tOnConsult.service';
import { isNullOrUndefined } from 'util';
import { Router } from '@angular/router';
import { AppSettings } from 'src/app/shared/AppSettings';
import { ApiResultDialogService } from 'src/app/services/Non-Master/ApiResultDialog.service';
import { MastersKeyStringValue } from 'src/app/services/Non-Master/MastersKeyStringValue.service';
import { DatePipe } from '@angular/common';
import { ApiResultHandlerService } from 'src/app/services/Non-Master/ApiResultHandler.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NavigationComponent } from 'src/app/pages/navigation/navigation.component';
import { tConsultHeadModelWithPatientInfo } from 'src/app/models/tConsultHeadModel';
import { ChineseDefaultModel, EnglishDefaultModel, SystemDefaultModel } from 'src/app/models/non-master-model/SystemDefaultModel';
import { tPrescriptionLineModel_withStock, tPrescriptionLineModel, tPrescriptionLineModel_withStock_withRemark } from 'src/app/models/tPrescriptionLineModel';

@Component({
  selector: 'app-search-pres-dialog',
  templateUrl: './search-pres-dialog.component.html',
  styleUrls: ['./search-pres-dialog.component.css']
})
export class SearchPresDialogComponent implements OnInit {

  selectedRowIndex: number = -1;
  showPortal = false;
    printHeader: tPrescriptionHeadModel;
    printLine: tPrescriptionLineModel_withStock_withRemark[];
    printLine1: tPrescriptionLineModel_withStock_withRemark[] = new Array;
    printLine2: tPrescriptionLineModel_withStock_withRemark[] = new Array;
    ClickToggle=false;

    isHidden_Sub1 = false;
    isHidden_Sub2 = false;
    isHidden_Sub3 = false;
  constructor(
    private log: LoggerService,
    public translate: TranslateService,
    private DateTimeConvertService: DateTimeConvertService,
    private tPrescriptionService: tPrescriptionService,
    private tOnConsultService: tOnConsultService,
    private router: Router,
    private apiResultDialogService: ApiResultDialogService,
    public datepipe: DatePipe,
    private ApiResultHandlerService: ApiResultHandlerService,
    public activeModal: NgbActiveModal,
  ) {
    let currentLanguage = localStorage.getItem('currentLanguage');
    translate.use(currentLanguage);
   }

  displayedColumns: string[] = [

    // 'action_button_title',

    'lineNumber',
    // 'clthConsultNumber',

    // 'action_button_newPrescription',
    'prescriptionDate',
    'prescriptionNumber',
  //  'prescriptionType',
    'diagonsis',
    'actionSelected'


    // 'patientChiName',
    // 'patientSurname',
    // 'patientFirstName',
    // 'bpInvoiceNumber',
    ];


  patientPhoneFilter = new FormControl();
  patientChiNameFilter = new FormControl();
  patientSurnameFilter = new FormControl();
  patientFirstNameFilter = new FormControl();

  diagonsisFilter = new FormControl();


  filteredValues = {
    patientChiName: '', patientSurname: '', patientFirstName: '', patientPhone: '', diagonsis: ''
  };

  togglePresConfirmModel: tPrescriptionHeadModelWithPatientBPInfo;
  private TAG = 'PrescriptionlistComponent';
  dataSource: MatTableDataSource<tPrescriptionHeadModelWithPatientBPInfo>;
  dataList: tPrescriptionHeadModelWithPatientBPInfo[];
  @ViewChild(MatPaginator) paginator: MatPaginator;

  @Input() shopID: string;
  @Input() onConsultDataList: tConsultHeadModelWithPatientInfo;

  prescriptionItemType_selection = ChineseDefaultModel.PresMediCateCodeList;



  ngOnInit() {
    this.getAllData();
  }
  getTypeDisplay(value){
    return this.prescriptionItemType_selection.find(p=>p.value==value).displayName
  }
  getAllData(): void {
    this.log.i(this.TAG, 'getAllData = ');
    this.log.i(this.TAG, 'shopID = ' + NavigationComponent.selectedShopID.toString());

    // let dbToday = this.DateTimeConvertService.ConvertCurrentDBDay(new Date()).toString();
    // this.log.i(this.TAG, 'dbToday = ' + dbToday.toString());

    // dbToday = '2019-09-12';


    this.tPrescriptionService.getAllHeadbyPatient(NavigationComponent.selectedShopID.toString(),
    this.onConsultDataList.patientID).subscribe(data => {

      this.log.i(this.TAG, JSON.stringify(data));

      this.dataList = data;
      this.dataSource = new MatTableDataSource<tPrescriptionHeadModelWithPatientBPInfo>(this.dataList);
      this.dataSource.paginator = this.paginator;


      this.patientChiNameFilter.valueChanges.subscribe((value) => {
        this.filteredValues['patientChiName'] = value;
        this.dataSource.filter = JSON.stringify(this.filteredValues);
      });

      this.patientSurnameFilter.valueChanges.subscribe((value) => {
        this.filteredValues['patientSurname'] = value;
        this.dataSource.filter = JSON.stringify(this.filteredValues);
      });

      this.patientFirstNameFilter.valueChanges.subscribe((value) => {
        this.filteredValues['patientFirstName'] = value;
        this.dataSource.filter = JSON.stringify(this.filteredValues);
      });

      this.patientPhoneFilter.valueChanges.subscribe((value) => {
        this.filteredValues['patientPhone'] = value;
        this.dataSource.filter = JSON.stringify(this.filteredValues);
      });

      this.diagonsisFilter.valueChanges.subscribe((value) => {
        this.filteredValues['diagonsis'] = value;
        this.dataSource.filter = JSON.stringify(this.filteredValues);
      });

      this.dataSource.filterPredicate = this.customFilterPredicate();

      // this.log.i(this.TAG,'filterPredicate = ' + this.customFilterPredicate());
    });

  }

  customFilterPredicate() {
    const myFilterPredicate = (data: tPrescriptionHeadModelWithPatientBPInfo, filter: string): boolean => {

      let searchString = JSON.parse(filter);

      return ((searchString.patientChiName.toLowerCase() === '' ||
        // tslint:disable-next-line:max-line-length
        (data.patientChiName != null && data.patientChiName.toString().trim().toLowerCase().indexOf(searchString.patientChiName.toLowerCase()) !== -1))
        &&
        (searchString.patientSurname.toLowerCase() === '' ||
        // tslint:disable-next-line:max-line-length
        (data.patientSurname != null && data.patientSurname.toString().trim().toLowerCase().indexOf(searchString.patientSurname.toLowerCase()) !== -1))
        )
        &&
        (searchString.patientFirstName.toLowerCase() === '' ||
        // tslint:disable-next-line:max-line-length
        (data.patientFirstName != null && data.patientFirstName.toString().trim().toLowerCase().indexOf(searchString.patientFirstName.toLowerCase()) !== -1))
        &&
        (searchString.patientPhone.toLowerCase() === '' ||
        // tslint:disable-next-line:max-line-length
        (data.patientPhone != null && data.patientPhone.toString().trim().toLowerCase().indexOf(searchString.patientPhone.toLowerCase()) !== -1))
        &&
        (searchString.diagonsis.toLowerCase() === '' ||
        // tslint:disable-next-line:max-line-length
        (data.diagonsis != null && data.diagonsis.toString().trim().toLowerCase().indexOf(searchString.diagonsis.toLowerCase()) !== -1))
        ;
    }
    return myFilterPredicate;
  }



  toPrescription(model: tPrescriptionHeadModelWithPatientBPInfo) {

    this.log.i(this.TAG, 'toPrescription: ' + JSON.stringify(model));

    let returnDisplayMsg = '';

    this.tOnConsultService.getOnConsultInfo(model.shopID, model.consultNumber).subscribe(data => {

      this.log.i(this.TAG + ' getOnConsultInfo', JSON.stringify(data));


      // if (!isNullOrUndefined(data[0].clthPrescripNumber)) {
      //   localStorage.removeItem('onConsultModel');
      //   localStorage.setItem('onConsultModel', JSON.stringify(model));

      //   this.router.navigate([AppSettings.Path_prescription]);

      //   return;
      // }


      this.translate.get('Message_CreatePrescription').subscribe((res: string) => {
        returnDisplayMsg = res;
      });

      const dialogRef = this.apiResultDialogService.openDialog(MastersKeyStringValue.ACTION_YNDialog, '', '', returnDisplayMsg);


      dialogRef.result.then((result) => {
        // on this.activeModal.close('Y');
        if (result === 'Y') {
          localStorage.removeItem('onConsultModel');
          localStorage.setItem('onConsultModel', JSON.stringify(model));

          localStorage.removeItem('prescriptionNumber');
          // localStorage.setItem('prescriptionNumber', model.prescriptionNumber;

          this.router.navigate([AppSettings.Path_prescription]);
        }
      }, (reason) => {
        // on dismiss
      });


    });
  }







  editPrescription(model: tPrescriptionHeadModelWithPatientBPInfo) {

    this.log.i(this.TAG, 'toPrescription: ' + JSON.stringify(model));
    this.tOnConsultService.getOnConsultInfo(model.shopID, model.consultNumber).subscribe(data => {

      this.log.i(this.TAG + ' getOnConsultInfo', JSON.stringify(data));

        localStorage.removeItem('onConsultModel');
        localStorage.setItem('onConsultModel', JSON.stringify(model));

        localStorage.removeItem('prescriptionNumber');
        localStorage.setItem('prescriptionNumber', model.prescriptionNumber);

        this.router.navigate([AppSettings.Path_prescription]);

        return;

    });
  }

  deletePrescription(model: tPrescriptionHeadModelWithPatientBPInfo) {

    this.log.i(this.TAG, 'toPrescription: ' + JSON.stringify(model));

    let returnDisplayMsg = '';

    this.translate.get('cPresDelete').subscribe((res: string) => {
      returnDisplayMsg = res + '?';
    });

    const dialogRef = this.apiResultDialogService.openDialog(MastersKeyStringValue.ACTION_YNDialog, '', '', returnDisplayMsg);


    dialogRef.result.then((result) => {
      // on this.activeModal.close('Y');
      if (result === 'Y') {
        this.deletePresAPI(model);
      }
    }, (reason) => {
      // on dismiss
    });
  }






  displayDateTime(currDate: Date) {

    if (!isNullOrUndefined(currDate)) {
      return this.datepipe.transform(currDate, 'yyyy/MM/dd');
      // return this.datepipe.transform(currDate, 'yyyy/MM/dd');
    }
    else
    {
      return '';
    }

  }


  deletePresAPI(model: tPrescriptionHeadModelWithPatientBPInfo): void {

    this.tPrescriptionService.deleteData(model).subscribe((data: any) => {
      // this.log.i(this.TAG, 'onSubmit success: ' + JSON.stringify(data) );

      // localStorage.removeItem('onConsultModel');
      // localStorage.setItem('onConsultModel', JSON.stringify(data.data));

      this.log.i(this.TAG, 'onSubmit success: ');

      this.ApiResultHandlerService.ResultHandler(
        data,
        AppSettings.Path_PrescriptionList,
        '');

      this.getAllData();

    },
      err => {
        this.ApiResultHandlerService.ErrHandler();
    });

  }



  selectRow(selectedModel: tPrescriptionHeadModelWithPatientBPInfo, index: number) {

    console.log("ClickSelectRow");
    if(this.ClickToggle!=true){
    this.selectedRowIndex = index;
    this.activeModal.close(selectedModel);
  }
  this.ClickToggle=false;
  }

  togglePresConfirm(){
    this.activeModal.close(this.togglePresConfirmModel);
  }

  togglePresView(selectedModel: tPrescriptionHeadModelWithPatientBPInfo) {
    var presNum=selectedModel.prescriptionNumber;
    this.togglePresConfirmModel=selectedModel;
    this.printLine=new Array;
    this.printLine1 = new Array;
    this.printLine2= new Array;
    console.log("Clicktoggle");
    this.ClickToggle=true;
    if (this.showPortal) {
      this.showPortal = false;
    } else if (!this.showPortal) {

    //  if (!isNullOrUndefined(this.printHeader)) {
    //    this.showPortal = true;
    //  } else {
        this.getPrintHead(presNum);
     // }

    }

  }
  getPrintHead(presNum: string) {

    this.printHeader = new tPrescriptionHeadModel();

    this.tPrescriptionService.getHead(this.onConsultDataList.shopID,
      presNum).subscribe(result => {
        this.printHeader = result[0];
        this.switchUI(this.printHeader.prescriptionItemType);
        this.log.d('getPrintHead', JSON.stringify(this.printHeader));

        this.getPrintLine(presNum);

        this.showPortal = true;
      });
  }


  getPrintLine(presNum: string) {


    this.printLine = new Array;
    this.printLine1 = new Array;
    this.printLine2 = new Array;




    this.tPrescriptionService.getPrintLine(NavigationComponent.selectedShopID.toString(),
      presNum).subscribe(data => {

        this.printLine = data;

        if (this.printLine.length > 15) {

          for (let i = 0; i < 15; i++) {

            if (this.printLine[i].mediName === null) {
              continue;
            }

            this.printLine1.push(this.printLine[i]);

            // this.lineSource1 = new MatTableDataSource<tPrescriptionLineModel_withStock>(this.line1);
          }

          for (let i = 15; i < this.printLine.length; i++) {
            this.printLine2.push(this.printLine[i]);

            // this.lineSource2 = new MatTableDataSource<tPrescriptionLineModel_withStock>(this.line2);
          }

        } else {
          this.printLine1 = this.printLine;

          const remainLines = 15 - this.printLine1.length;

          if (remainLines > 0) {

            for (let i = 0; i < remainLines; i++) {

              // const lineEmpty = new tPrescriptionLineModel_withStock_withRemark;
              // lineEmpty.mediName = '&nbsp;';

              // this.lineEmpty.push(lineEmpty);
            }


          }

          // this.lineSource1 = new MatTableDataSource<tPrescriptionLineModel_withStock>(this.line1);
        }

      });

  }


  switchUI(inputValue) {


      const value = inputValue;

      if (value === 1 || value==3) {
        this.isHidden_Sub1 = false;
        this.isHidden_Sub2 = true;
        this.isHidden_Sub3 = true;


      } else if (value === 4) {
        this.isHidden_Sub1 = true;
        this.isHidden_Sub2 = false;
        this.isHidden_Sub3 = true;
      } else if (value === 2) {
        this.isHidden_Sub1 = true;
        this.isHidden_Sub2 = true;
        this.isHidden_Sub3 = false;

      }
    }
}
